import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function TeamSearchEmptyState() {
  return /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: "empty-state-charts",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.installPermissions.options.specificTeams.emptyState.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.installPermissions.options.specificTeams.emptyState.description"
    })
  });
}